import httpService from "@src/utility/httpService";
import { VBC_INFLATORS } from '@src/CommonComponents/constant/api_url_constants';
import { checkIsInternal } from '@src/utility/createStorage';
import { config } from '@uhg-abyss/web/tools/config';

const _httpService = new httpService();

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL') || '');
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL') || '');
}

// API service function for fetching Inflators data
export const getInflatorsData = async (payload: any = {}) => {
  try {
    const responseData: any = await _httpService.push(VBC_INFLATORS, payload);
    return responseData;
  } catch (error: any) {
    console.error('Error fetching VBC Inflators data:', error);
    return null;
  }
};